const liveThemes = {
  '#cb70ff': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(91, 104, 255, 0.35), rgba(236, 129, 255, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(255, 214, 102, 0.9), rgba(255, 122, 214, 0.85), rgba(126, 208, 255, 0.85))',
    liveBadgeShadow: '0 10px 22px rgba(255, 182, 255, 0.35), 0 0 18px rgba(255, 238, 175, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(118, 103, 255, 0.35), rgba(236, 129, 255, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(193, 120, 255, 0.92), rgba(140, 96, 255, 0.92))',
    sliderFooterBackground: 'rgba(60, 45, 105, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(236, 129, 255, 0.6), rgba(121, 134, 255, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(236, 129, 255, 0.25), rgba(101, 114, 255, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(236, 129, 255, 0.5), rgba(121, 134, 255, 0.5))',
    primaryText: 'rgba(236, 129, 255, 0.9)',
  },
  '#ffb969': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(255, 200, 120, 0.35), rgba(255, 153, 102, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(255, 214, 102, 0.92), rgba(255, 172, 102, 0.88), rgba(255, 132, 102, 0.88))',
    liveBadgeShadow: '0 10px 22px rgba(255, 176, 124, 0.35), 0 0 18px rgba(255, 214, 166, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(255, 180, 102, 0.35), rgba(255, 120, 92, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(255, 178, 102, 0.92), rgba(255, 134, 102, 0.92))',
    sliderFooterBackground: 'rgba(92, 60, 45, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(255, 185, 102, 0.6), rgba(255, 140, 96, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(255, 185, 105, 0.25), rgba(255, 140, 96, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(255, 185, 105, 0.5), rgba(255, 140, 96, 0.5))',
    primaryText: 'rgba(255, 185, 105, 0.95)',
  },
  '#55d685': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(85, 214, 133, 0.35), rgba(110, 255, 196, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(136, 255, 182, 0.92), rgba(85, 214, 133, 0.88), rgba(80, 200, 166, 0.88))',
    liveBadgeShadow: '0 10px 22px rgba(110, 255, 196, 0.35), 0 0 18px rgba(170, 255, 214, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(85, 214, 133, 0.35), rgba(64, 180, 140, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(85, 214, 133, 0.92), rgba(60, 176, 126, 0.92))',
    sliderFooterBackground: 'rgba(38, 74, 58, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(85, 214, 133, 0.6), rgba(64, 180, 140, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(85, 214, 133, 0.25), rgba(64, 180, 140, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(85, 214, 133, 0.5), rgba(64, 180, 140, 0.5))',
    primaryText: 'rgba(85, 214, 133, 0.9)',
  },
  '#0fefff': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(15, 239, 255, 0.35), rgba(91, 167, 255, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(102, 255, 248, 0.92), rgba(15, 239, 255, 0.88), rgba(102, 185, 255, 0.88))',
    liveBadgeShadow: '0 10px 22px rgba(120, 255, 248, 0.35), 0 0 18px rgba(146, 214, 255, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(15, 239, 255, 0.35), rgba(60, 170, 255, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(15, 239, 255, 0.92), rgba(71, 169, 255, 0.92))',
    sliderFooterBackground: 'rgba(34, 72, 88, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(15, 239, 255, 0.6), rgba(71, 169, 255, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(15, 239, 255, 0.25), rgba(71, 169, 255, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(15, 239, 255, 0.5), rgba(71, 169, 255, 0.5))',
    primaryText: 'rgba(15, 239, 255, 0.9)',
  },
  '#ff99f6': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(255, 153, 246, 0.35), rgba(255, 118, 213, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(255, 196, 246, 0.92), rgba(255, 153, 246, 0.88), rgba(255, 121, 198, 0.88))',
    liveBadgeShadow: '0 10px 22px rgba(255, 173, 246, 0.35), 0 0 18px rgba(255, 210, 250, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(255, 153, 246, 0.35), rgba(255, 121, 198, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(255, 153, 246, 0.92), rgba(236, 112, 214, 0.92))',
    sliderFooterBackground: 'rgba(92, 50, 90, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(255, 153, 246, 0.6), rgba(236, 112, 214, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(255, 153, 246, 0.25), rgba(236, 112, 214, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(255, 153, 246, 0.5), rgba(236, 112, 214, 0.5))',
    primaryText: 'rgba(255, 153, 246, 0.9)',
  },
  '#ff6181': {
    hourTitleBackground: 'linear-gradient(120deg, rgba(255, 97, 129, 0.35), rgba(255, 132, 164, 0.35))',
    liveBadgeBackground: 'linear-gradient(120deg, rgba(255, 150, 170, 0.92), rgba(255, 97, 129, 0.88), rgba(255, 132, 164, 0.88))',
    liveBadgeShadow: '0 10px 22px rgba(255, 124, 154, 0.35), 0 0 18px rgba(255, 184, 200, 0.35)',
    statBadgeBackground: 'linear-gradient(135deg, rgba(255, 97, 129, 0.35), rgba(255, 130, 152, 0.35))',
    footerBarBackground: 'linear-gradient(135deg, rgba(255, 97, 129, 0.92), rgba(235, 86, 129, 0.92))',
    sliderFooterBackground: 'rgba(92, 44, 60, 0.85)',
    buttonBackground: 'linear-gradient(120deg, rgba(255, 97, 129, 0.6), rgba(235, 86, 129, 0.6))',
    pageTitleBackground: 'linear-gradient(135deg, rgba(255, 97, 129, 0.25), rgba(235, 86, 129, 0.15))',
    fabSelectedBackground: 'linear-gradient(135deg, rgba(255, 97, 129, 0.5), rgba(235, 86, 129, 0.5))',
    primaryText: 'rgba(255, 97, 129, 0.9)',
  },
};

const fallbackColor = '#cb70ff';

export const getLiveTheme = (color) => {
  if (!color) {
    return liveThemes[fallbackColor];
  }
  const normalized = color.toLowerCase();
  return liveThemes[normalized] || liveThemes[fallbackColor];
};
